import { Actions, Can, Subjects } from '@efexteam/permission-manager';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FilePicker from '../../../components/common/FilePicker';
import SelectTemplate from '../../../components/selectTemplate/SelectTemplate';

interface IBulksPaymentsProps {
  handleFilesBulksDocument: (data: FileList | undefined) => void;
  handleUploadFile: () => void;
}

const BulksPayments = ({
  handleFilesBulksDocument,
  handleUploadFile,
}: IBulksPaymentsProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <Alert variant="outlined" severity="success" className="!my-4">
        <span className="font-bold mr-[5px]">{t('note')}:</span>
        {t('noteSendBulks')}
      </Alert>
      <Can action={Actions.CREATE} subject={Subjects.BULK_PAYMENTS}>
        <SelectTemplate />
        <FilePicker
          handleFilesBulksDocument={handleFilesBulksDocument}
          reloadFiles={handleUploadFile}
          accept={[
            '.csv',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
          ]}
        />
      </Can>
    </div>
  );
};

export default BulksPayments;
